import React from 'react'
import { useTranslation } from "react-i18next";
import SeeMoreText from "./SeeMoreText";

export interface ICreditPackage {
    credit_package_id: string;
    club_id: string;
    title: string;
    period: number;
    information: string;
    usp: string[];
    price: number;
    credit: number;
  }

const CreditPackageCard: React.FC<
  ICreditPackage & {
    Handler: () => JSX.Element;
    timezone?: string;
    currency?: string;
  }
> = ({
  title,
  information,
  usp,
  period,
  credit,
  Handler,
}) => {
    const { t } = useTranslation();
  return (
    <div className="rounded-[10px] border-2 border-secondary border-opacity-[0.15] px-2 py-5 sm:px-5 text-center min-w-[250px] flex flex-col justify-between max-h-[450px] md:max-h-full overflow-y-auto">
      <p className="text-xl font-semibold break-words">{title}</p>
      <p className="text-sm mt-3 break-words">
        {t("period")}: {period}{" "}
        {period === 1 ? t("month") : t("months")}
      </p>
      {information ? (
        <SeeMoreText
          numberOfWords={80}
          text={information}
        />
      ) : null}
      <div />
      <div className="max-w-fit mx-auto mt-4 flex flex-col gap-1 items-center justify-center">
        {usp[0] && usp[0]?.trim()?.length > 0 ? <p className="text-[15px] flex gap-2 items-start capitalize break-words">
            <img
                className="mt-1.5"
                src="/images/check-mark.svg"
                alt="check"
            />
            <span> {usp[0]} </span>
        </p> : null}
        {usp[1] && usp[1]?.trim()?.length > 0 ? <p className="text-[15px] flex gap-2 items-start capitalize break-words">
            <img
                className="mt-1.5"
                src="/images/check-mark.svg"
                alt="check"
            />
            <span> {usp[1]} </span>
        </p> : null}
        {usp[2] && usp[2]?.trim()?.length > 0 ? <p className="text-[15px] flex gap-2 items-start capitalize break-words">
            <img
                className="mt-1.5"
                src="/images/check-mark.svg"
                alt="check"
            />
            <span> {usp[2]} </span>
        </p> : null}
        {usp[3] && usp[3]?.trim()?.length > 0? <p className="text-[15px] flex gap-2 items-start capitalize break-words">
            <img

                className="mt-1.5"
                src="/images/check-mark.svg"
                alt="check"
            />
            <span> {usp[3]} </span>
        </p> : null}
      </div>
      <div className="flex gap-1 justify-center items-center mt-5 mb-1 font-bold text-[19px]">
        <img src="/images/coinStack.svg" alt="coins" />
        <p className="break-words">{credit}</p>
      </div>
      <div>
        <Handler />
      </div>
    </div>
  );
};

export default CreditPackageCard;